import { Box, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { TrackControlsProps } from "../types";
import CircularProgress from "@mui/material/CircularProgress";
import { trackControlsStyles } from "../styles";

export const TrackControls: React.FC<TrackControlsProps> = ({
  loaded,
  handlePlay,
  isPlaying,
  id,
  isTrackLoading,
}) => {
  return (
    <>
      <Box sx={{ marginRight: "5px", zIndex: 1000 }}>
        <IconButton
          aria-label="play"
          size="small"
          onClickCapture={(e) => {
            e.stopPropagation();
            handlePlay(id!);
          }}
          sx={{ zIndex: 1000, padding: 0.5 }}
        >
          {isTrackLoading ? (
            <CircularProgress
              size={20}
              sx={trackControlsStyles.playbackIcons}
            />
          ) : isPlaying ? (
            <PauseIcon sx={trackControlsStyles.playbackIcons} />
          ) : (
            <PlayArrowIcon
              id="play-button"
              sx={trackControlsStyles.playbackIcons}
            />
          )}
        </IconButton>
      </Box>
    </>
  );
};
